module.exports = __webpack_public_path__ + "static/organic-search-row-six-hero-1-20917dad343c54140d2465770f14193d.png";